import u from "./extends3.mjs";
import "react";
import { DIALOG_WIDTH as f } from "./dimensions.mjs";
import { jsx as r } from "react/jsx-runtime";
import s from "./styled.mjs";
import g from "./Dialog2.mjs";
import t from "./dialogClasses.mjs";
import P from "./DialogContent3.mjs";
import D from "./Fade.mjs";
const v = s(g)({
  [`& .${t.container}`]: {
    outline: 0
  },
  [`& .${t.paper}`]: {
    outline: 0,
    minWidth: f
  }
}), T = s(P)({
  "&:first-of-type": {
    padding: 0
  }
});
function I(e) {
  var n, l;
  const {
    children: a,
    onDismiss: m,
    open: p,
    slots: o,
    slotProps: i
  } = e, d = (n = o?.dialog) != null ? n : v, c = (l = o?.mobileTransition) != null ? l : D;
  return /* @__PURE__ */ r(d, u({
    open: p,
    onClose: m
  }, i?.dialog, {
    TransitionComponent: c,
    TransitionProps: i?.mobileTransition,
    PaperComponent: o?.mobilePaper,
    PaperProps: i?.mobilePaper,
    children: /* @__PURE__ */ r(T, {
      children: a
    })
  }));
}
export {
  I as PickersModalDialog
};
//# sourceMappingURL=PickersModalDialog.mjs.map
